export default "__VITE_PUBLIC_ASSET__568c2a7d__"